module.exports = __webpack_public_path__ + "static/media/acc.92662530.svg";